import type { KpiComparison, KpiComparisonPeriod } from "@types";

interface MetricWithVariation {
  value: number;
  previousValue: number;
  variationPercent: number | null;
  currentPeriod?: KpiComparisonPeriod | null;
  previousPeriod?: KpiComparisonPeriod | null;
}

export const toKpiComparison = (metric?: MetricWithVariation | null): KpiComparison | null =>
  metric
    ? {
        currentValue: metric.value,
        previousValue: metric.previousValue,
        variationPercent: metric.variationPercent,
        currentPeriod: metric.currentPeriod,
        previousPeriod: metric.previousPeriod,
      }
    : null;

interface KpiComparisonPeriods {
  currentPeriod?: KpiComparisonPeriod | null;
  previousPeriod?: KpiComparisonPeriod | null;
}

export const resolveKpiComparison = (raw: any, fallbackPeriods?: KpiComparisonPeriods): KpiComparison | null => {
  if (!raw) return null;

  const currentValue = raw.currentValue ?? raw.value;
  const { previousValue, variationPercent } = raw;

  if (currentValue == null || previousValue == null || variationPercent == null) return null;

  return {
    currentValue: Number(currentValue),
    previousValue: Number(previousValue),
    variationPercent: Number(variationPercent),
    currentPeriod: raw.currentPeriod ?? fallbackPeriods?.currentPeriod ?? null,
    previousPeriod: raw.previousPeriod ?? fallbackPeriods?.previousPeriod ?? null,
  };
};
